import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "addingAccountsWidget"
};
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useBanking } from '@/composables/useBanking';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AwaitBankAccountPanel',
    props: {
        origCount: {}
    },
    emits: ["accountAdded"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const state = useAppState();
        useAuth();
        const { getBankingInfo, clearBankingInfo } = useBanking();
        const cookies = getCurrentInstance()?.appContext.config.globalProperties.$cookies;
        const adding = ref(true);
        let interval = null;
        function cancel() {
            adding.value = false;
            cookies?.remove('waitBank');
        }
        function waitLinkedAccount() {
            interval = setInterval(() => {
                if (!adding.value) {
                    if (interval)
                        clearInterval(interval);
                    return;
                }
                clearBankingInfo();
                getBankingInfo(() => {
                    if (state.bankInfo && state.bankInfo.accounts.length > props.origCount) {
                        adding.value = false;
                        cookies?.remove('waitBank');
                        emit('accountAdded');
                        if (interval)
                            clearInterval(interval);
                    }
                });
            }, 5000);
        }
        onMounted(() => {
            waitLinkedAccount();
        });
        onBeforeUnmount(() => {
            if (interval)
                clearInterval(interval);
        });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            return (adding.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "float-left" }, "Searching for new accounts . . .", -1)),
                    _createElementVNode("div", {
                        class: "float-right",
                        onClick: _cache[0] || (_cache[0] = ($event) => (cancel()))
                    }, "Cancel"),
                    _createVNode(_component_v_progress_linear, {
                        indeterminate: "",
                        color: "#332847"
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
